import { SearchUserEnriched } from 'lib-search-types';

/**
 * Ordering used in the transfer-to-agent flows: working agents first, then
 * agents in wrap-up, then away, then offline. The search filter already
 * excludes offline agents, but we keep the rank for completeness so the
 * comparator is robust if the filter is relaxed.
 */
export const rankSearchMember = (member: SearchUserEnriched): number => {
  if (member.is_online === false) return 4;
  if (member.is_working) return member.has_acw ? 2 : 1;
  return 3;
};
